import React, { useState, useEffect } from 'react';
import FormStep from "./FormStep";

const TicketTypeSelection = ({ nextStep, prevStep, formData, setFormData }) => {
  const [ticketType, setTicketType] = useState(formData.ticketType || 'standard');
  const [errors, setErrors] = useState({});

  // Check if early bird is available
  const earlyBirdAvailable = formData.event?.earlyBirdActive && formData.event?.earlyBirdPrice > 0;
  
  // Get custom tickets if available
  const customTickets = formData.event?.customTickets || [];
  
  // Get custom standard ticket labels
  const standardTicketLabel = formData.event?.ticketPriceLabel || 'Standard';
  const standardTicketDescription = formData.event?.ticketPriceDescription || 'Standard price for all attendees';
  
  // Format prices for display
  const standardPrice = formData.event?.price > 0 ? `£${formData.event.price.toFixed(2)}` : 'Free';
  const earlyBirdPrice = formData.event?.earlyBirdPrice > 0 ? `£${formData.event.earlyBirdPrice.toFixed(2)}` : 'Free';
  
  // For backward compatibility - check if we have old style local authority price
  const localAuthorityAvailable = !customTickets.some(ticket => ticket.id === 'local-authority') && 
                                 formData.event?.localAuthorityPrice > 0;
  const localAuthorityPrice = localAuthorityAvailable ? 
                             `£${formData.event.localAuthorityPrice.toFixed(2)}` : 'Free';

  const handleContinue = () => {
    // Update form data with the selected ticket type
    setFormData({
      ...formData,
      ticketType: ticketType
    });
    
    // Move to the next step
    nextStep();
  };

  const handleTicketTypeChange = (e) => {
    setTicketType(e.target.value);
  };

  return (
    <FormStep
      title="Select Ticket Type"
      onBack={prevStep}
      onNext={handleContinue}
      isNextDisabled={false}
    >
      <div className="ticket-type-selection">
        <p className="description">Please select your ticket type for {formData.event?.name || 'the event'}:</p>
        
        <div className="ticket-options">
          <div className="ticket-option">
            <label className="radio-container">
              <input
                type="radio"
                name="ticketType"
                value="standard"
                checked={ticketType === 'standard'}
                onChange={handleTicketTypeChange}
              />
              <div className="ticket-info">
                <div className="ticket-name">{standardTicketLabel}</div>
                <div className="ticket-price">{standardPrice}</div>
                <div className="ticket-description">{standardTicketDescription}</div>
              </div>
            </label>
          </div>
          
          {earlyBirdAvailable && (
            <div className="ticket-option">
              <label className="radio-container">
                <input
                  type="radio"
                  name="ticketType"
                  value="early_bird"
                  checked={ticketType === 'early_bird'}
                  onChange={handleTicketTypeChange}
                />
                <div className="ticket-info">
                  <div className="ticket-name">Early Bird Ticket</div>
                  <div className="ticket-price">{earlyBirdPrice}</div>
                  <div className="ticket-description">
                    Limited time offer! Ends on {formData.event?.earlyBirdEndDate ? new Date(formData.event.earlyBirdEndDate).toLocaleDateString() : 'soon'}
                  </div>
                </div>
              </label>
            </div>
          )}
          
          {/* Show custom ticket options */}
          {customTickets.map((ticket, index) => (
            <div className="ticket-option" key={ticket.id || `custom-${index}`}>
              <label className="radio-container">
                <input
                  type="radio"
                  name="ticketType"
                  value={ticket.id}
                  checked={ticketType === ticket.id}
                  onChange={handleTicketTypeChange}
                />
                <div className="ticket-info">
                  <div className="ticket-name">{ticket.name}</div>
                  <div className="ticket-price">£{ticket.price.toFixed(2)}</div>
                  <div className="ticket-description">{ticket.description || `Special price for ${ticket.name} attendees`}</div>
                </div>
              </label>
            </div>
          ))}
        </div>
      </div>
    </FormStep>
  );
};

export default TicketTypeSelection; 